module.exports = __webpack_public_path__ + "img/b9f79f3.jpg";